const ruleAction = (type, name) => {
  const message = `Please ${type} ${name}`
  return [{
    required: true,
    message: message
  }]
}

export default {
  companyForm: {
    venderType: "modulr",
    legalEntity: "GB",
    company: {
      expectedMonthlySpend: 0,
      industryCode: "",
      tcsVersion: 1,
      typeOfBusiness: "",
      registrationNumber: "",
      name: "",
      addressnumber: "",
      street: "",
      countrycode: "",
      zipcode: "",
      city: ""
    },
    associates: [{
        applicant: true,
        dateOfBirth: "",
        email: "",
        firstName: "",
        lastName: "",
        position: "BENE_OWNER",
        telephone: "",
        addressnumber: "",
        street: "",
        city: "",
        countrycode: "",
        zipcode: "",
        ownership: 0
      },
      {
        applicant: false,
        dateOfBirth: "",
        email: "",
        firstName: "",
        lastName: "",
        position: "DIRECTOR",
        telephone: "",
        addressnumber: "",
        street: "",
        city: "",
        countrycode: "",
        zipcode: "",
        ownership: 0
      },

    ]
  },


  companyRules: {
    company_countrycode: ruleAction('enter', 'Country code'),
    company_zipcode: ruleAction('enter', 'Zipcode'),
    company_addressnumber: ruleAction('enter', 'Address number'),
    // company_refinement: ruleAction('enter', 'Refinement'),
    company_street: ruleAction('enter', 'Street'),
    company_city: ruleAction('enter', 'City'),
    company_regulateFinancial: ruleAction('enter', 'Regulate Financial'),
    company_registrationNumber: ruleAction('enter', 'Registration Number'),
    company_approvedate: ruleAction('enter', 'Approve Date'),
    company_email: [{
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: "blur",
          }],
    company_natureofbusiness: ruleAction('enter', 'Nature of Business'),
    company_webSite: ruleAction('enter', 'Website'),
    company_name: ruleAction('enter', 'Company name'),
    company_tradingName: ruleAction('enter', 'Trading Name'),
    company_telephone: ruleAction('enter', 'Telephone'),
    company_typeOfBusiness: ruleAction('enter', 'Type Of Business'),
    company: {
      expectedMonthlySpend: [
        { required: true, message: 'Expected monthly spend is required'},
      ],
      industryCode: ruleAction('enter', 'Industry Code'),
      legalEntity: ruleAction('enter', 'Legal Entity'),
      typeOfBusiness: [
        { required: true, message: 'Please select type of business', trigger: 'change' }
      ],
      registrationNumber: ruleAction('change', 'Registration Number'),
      name: ruleAction('enter', 'Company name'),
      addressnumber: ruleAction('enter', 'Address number'),
      street: ruleAction('enter', 'Street'),
      countrycode: ruleAction('enter', 'Country code'),
      zipcode: ruleAction('enter', 'Zipcode'),
      city: ruleAction('enter', 'City')
    },

    associates: {
      dateOfBirth: ruleAction('enter', 'Date of birth'),
      email: [{
        required: true,
        message: "Please enter email",
        trigger: "blur",
      },
      {
        type: "email",
        message: "Please enter correct email format",
        trigger: "blur",
      }],
      firstName: ruleAction('enter', 'First name'),
      lastName: ruleAction('enter', 'Last name'),
      position: ruleAction('enter', 'Position'),
      telephone: ruleAction('enter', 'Phone number'),
      addressnumber: ruleAction('enter', 'Address number'),
      street: ruleAction('enter', 'Street'),
      city: ruleAction('enter', 'City'),
      countrycode: ruleAction('enter', 'Country code'),
      zipcode: ruleAction('enter', 'Zipcode')
    }

  },

  typeOfBusinessList: [{
      value: "LLC",
      label: "LLC",
    },
    {
      value: "PLC",
      label: "PLC",
    },
    {
      value: "SOLETRADER",
      label: "SOLETRADER",
    },
    {
      value: "OPARTNRSHP",
      label: "OPARTNRSHP",
    },
    {
      value: "LPARTNRSHP",
      label: "LPARTNRSHP",
    },
    {
      value: "LLP",
      label: "LLP",
    },
    {
      value: "CHARITY",
      label: "CHARITY",
    },
    {
      value: "INDIVIDUAL",
      label: "INDIVIDUAL",
    },
    {
      value: "PCM INDIVIDUAL",
      label: "PCM_INDIVIDUAL",
    },
    {
      value: "PCMBUSINESS",
      label: "PCM_BUSINESS",
    },
  ],

  directorPositionList: [
    {
      value: "DIRECTOR",
      label: "DIRECTOR"
    },
    {
      value: "PARTNER",
      label: "PARTNER"
    },
    {
      value: "CSECRETARY",
      label: "CSECRETARY"
    },
    {
      value: "SOLETRADER",
      label: "SOLETRADER"
    },
    {
      ownership: 15,
      value: "BENE_OWNER",
      label: "BENE_OWNER"
    },
    {
      value: "C_INTEREST",
      label: "C_INTEREST"
    },
    {
      value: "INDIVIDUAL",
      label: "INDIVIDUAL"
    },
    {
      value: "PCM_INDIVIDUAL",
      label: "PCM_INDIVIDUAL"
    },
  ],

  getCompanyForm(){
    return JSON.parse(JSON.stringify(this.companyForm))
  },
  getCompanyRulesForm(){
    return JSON.parse(JSON.stringify(this.companyRules))
  },
  getTypeOfBusinessList(){
    return JSON.parse(JSON.stringify(this.typeOfBusinessList))
  },
  getDirectorPositionList(){
    return JSON.parse(JSON.stringify(this.directorPositionList))
  }

}